export default {
  preset: 'Пресет',
  presets: 'Пресеты',
  clear: 'Очистить фильтр',

  isActive: {
    true: 'Только активные',
    false: 'Только не активен'
  }
}
